<div class="content-msjbitacora-primary">
<div class="content-msjbitacora background-gris1">
 <span class="d-block fst-italic">Última actualización por </span>
        <h5><strong> <span class="d-block">{{perfilAgente}} {{nombreAgente}} ({{idAgente}})</span>
        {{fechaRegistro}}</strong></h5>
</div>
</div>

